var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 31,
    viewBox: "0 0 22 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.92 30.66L10.248 29.904C9.828 29.484 0 17.892 0 10.92C0 4.872 4.872 0 10.92 0C16.968 0 21.84 4.872 21.84 10.92C21.84 17.892 12.012 29.484 11.592 29.988L10.92 30.66ZM10.92 1.68C5.796 1.68 1.68 5.796 1.68 10.92C1.68 16.296 8.736 25.368 10.92 28.056C13.104 25.368 20.16 16.296 20.16 10.92C20.16 5.796 16.044 1.68 10.92 1.68Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9201 15.12C8.56809 15.12 6.72009 13.272 6.72009 10.92C6.72009 8.568 8.56809 6.72 10.9201 6.72C13.2721 6.72 15.1201 8.568 15.1201 10.92C15.1201 13.272 13.2721 15.12 10.9201 15.12ZM10.9201 8.4C9.49209 8.4 8.40009 9.492 8.40009 10.92C8.40009 12.348 9.49209 13.44 10.9201 13.44C12.3481 13.44 13.4401 12.348 13.4401 10.92C13.4401 9.492 12.3481 8.4 10.9201 8.4Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.19e394d3b396eaaa8716b9ba65917fac.svg";
export { ForwardRef as ReactComponent };